import React from 'react';

const Stepper = (props) => (
    <ul className="progress-tracker progress-tracker--text progress-tracker--center">
        {props.children}
    </ul>
);

export default Stepper;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/stepper/stepper.jsx
 **/